import * as React from "react";

const version = require('../../version.js');

export class HealthPage extends React.Component<any, any> {


    render() {
        const pipelineCreationTime = version.pipelineCreationTime || version.buildTime;
        const commitTimestamp = version.commitTimestamp || "";
        let healthResponse = {
            healthy: true,
            version: version.version,
            buildTime: version.buildTime,
            pipelineCreationTime,
            commitTimestamp,
        }

        return JSON.stringify(healthResponse, null, 4)
    }
}
